import { render, staticRenderFns } from "./PageViewsChart.vue?vue&type=template&id=99c4255e"
import script from "./PageViewsChart.vue?vue&type=script&lang=js"
export * from "./PageViewsChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../website-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports